// NOTE: on focus on email input is not currently handeld & sumit is hooked on login link sent.
export default (EventBus) => {
  const emitContentGateEvent = ({ action, data }) => {
    EventBus.$emit('identity-x-newsletter-form-action', {
      ...data,
      category: 'Content Gate',
      action,
    });
  };

  // in content login form VIEW
  EventBus.$on('identity-x-login-mounted', (data) => {
    const { actionSource } = data;
    if (actionSource === 'contentGate') emitContentGateEvent({ action: 'View', data });
  });

  // in content login form SUBMIT
  EventBus.$on('identity-x-login-link-sent', (data) => {
    const { actionSource } = data;
    if (actionSource === 'contentGate') emitContentGateEvent({ action: 'Submit', data });
  });

  // in content login form ERROR
  EventBus.$on('identity-x-login-errored', (data) => {
    const { actionSource } = data;
    if (actionSource === 'contentGate') emitContentGateEvent({ action: 'Error', data });
  });
};
